import { render, staticRenderFns } from "./UploadDocumentEdit.vue?vue&type=template&id=03d50629&"
import script from "./UploadDocumentEdit.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports